import React from "react"

export default function BplsTimeIcon(props) {
  const {
    viewBox = "0 0 947.000000 858.000000",
    fill = "#000000",
    width = "947.000000pt",
    height = "858.000000pt"
  } = props
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g transform="translate(0.000000,858.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
        <path
          d="M3503 8456 c-95 -23 -176 -71 -245 -144 -72 -77 -102 -132 -125 -233
l-15 -69 -192 0 c-207 0 -252 -8 -328 -58 -51 -33 -106 -107 -123 -166 -8 -27
-15 -85 -15 -128 l0 -78 -513 0 c-483 0 -519 -1 -593 -20 -98 -25 -172 -68
-249 -145 -70 -69 -128 -177 -144 -269 -15 -80 -15 -6539 -1 -6617 18 -95 81
-208 158 -280 78 -74 142 -111 233 -136 60 -17 194 -18 2324 -18 2486 0 2307
-5 2440 63 124 64 220 181 271 332 18 53 19 156 19 3340 0 2688 -2 3294 -13
3335 -7 28 -29 83 -49 122 -42 87 -148 193 -237 236 -109 54 -146 57 -697 57
l-506 0 -6 94 c-3 61 -12 109 -25 138 -29 65 -95 133 -160 165 -56 28 -60 28
-268 31 l-211 3 -11 62 c-34 184 -177 332 -369 381 -74 19 -274 20 -350 2z
m355 -219 c116 -62 163 -137 169 -271 8 -155 10 -156 318 -156 257 0 284 -5
323 -55 21 -27 22 -36 22 -297 0 -298 -3 -313 -63 -345 -30 -17 -91 -18 -952
-18 -871 0 -922 1 -948 18 -16 10 -37 32 -47 50 -18 29 -20 52 -20 285 0 289
4 308 71 342 35 18 60 20 284 20 l247 0 27 28 c25 24 28 37 35 117 11 144 60
225 170 280 46 23 61 25 186 25 122 0 140 -2 178 -23z m-1397 -987 c3 -83 11
-138 22 -163 24 -56 110 -142 170 -168 l52 -24 940 -3 c710 -2 954 0 999 9 71
15 138 59 187 123 50 66 60 103 66 239 l5 118 512 -3 511 -3 60 -24 c81 -32
164 -116 194 -195 l21 -57 0 -3257 c0 -2087 -4 -3270 -10 -3292 -17 -61 -73
-143 -124 -182 -100 -74 89 -69 -2416 -66 l-2245 3 -53 24 c-70 31 -154 122
-179 193 -17 51 -18 170 -18 3323 l0 3270 26 55 c52 108 138 177 249 199 25 5
266 8 535 7 l490 -1 6 -125z"
        />
        <path
          d="M2496 6328 c-14 -13 -107 -147 -207 -298 -100 -151 -185 -279 -190
-284 -5 -6 -40 21 -86 66 -43 41 -89 81 -102 87 -57 31 -141 -25 -141 -95 0
-39 34 -81 196 -236 91 -88 106 -98 139 -98 50 0 65 10 107 72 207 306 440
667 445 689 17 89 -95 156 -161 97z"
        />
        <path
          d="M3194 5928 c-62 -30 -55 -146 11 -176 19 -9 221 -12 800 -12 l773 0
31 26 c38 32 49 80 27 122 -9 17 -25 36 -35 42 -27 14 -1578 13 -1607 -2z"
        />
        <path
          d="M2511 4787 c-15 -7 -100 -127 -219 -307 -107 -162 -197 -297 -199
-299 -2 -3 -32 24 -67 60 -90 93 -113 109 -156 109 -72 0 -119 -71 -90 -139 6
-16 72 -88 145 -160 131 -129 134 -131 178 -131 28 0 53 7 66 18 11 9 126 177
256 372 263 396 262 395 201 456 -36 36 -70 43 -115 21z"
        />
        <path
          d="M3179 4361 c-23 -23 -29 -38 -29 -71 0 -33 6 -48 29 -71 l29 -29 781
0 c562 0 787 3 805 11 25 12 56 63 56 94 0 25 -28 73 -49 85 -13 7 -286 10
-806 10 l-787 0 -29 -29z"
        />
        <path
          d="M2533 3241 c-13 -3 -31 -13 -41 -22 -10 -9 -103 -144 -207 -300 -103
-156 -189 -286 -191 -288 -2 -3 -44 35 -93 82 -83 81 -91 87 -130 87 -67 0
-113 -61 -96 -127 8 -32 244 -276 289 -300 36 -19 86 -10 113 20 20 21 124
177 371 551 122 185 132 212 90 261 -26 29 -72 44 -105 36z"
        />
        <path
          d="M3179 2811 c-23 -23 -29 -38 -29 -71 0 -33 6 -48 29 -71 l29 -29 781
0 c583 0 787 3 806 12 29 13 55 55 55 88 0 31 -29 76 -57 89 -17 8 -264 11
-804 11 l-781 0 -29 -29z"
        />
        <path
          d="M2488 1663 c-24 -26 -115 -160 -303 -448 -43 -66 -82 -124 -86 -129
-5 -6 -45 26 -98 77 -79 77 -93 87 -125 87 -45 0 -80 -22 -96 -60 -25 -61 -10
-86 143 -238 152 -151 168 -159 229 -131 24 10 481 686 501 740 36 95 -95 176
-165 102z"
        />
        <path
          d="M3210 1279 c-55 -22 -78 -98 -44 -147 37 -54 13 -52 829 -52 831 0
808 -2 840 60 21 41 13 89 -21 121 l-26 24 -776 2 c-494 1 -786 -2 -802 -8z"
        />
      </g>
    </svg>
  )
}
